module.exports = __webpack_public_path__ + "img/future-house.44870917.png";